const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('categoryRestrictedSelect', ['Application', function (Application) {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      options: '=',
      user: '=?',
      content: '=?',
      onChange: '&?',
      allowAll: '@?',
      manager: '=?',
      viewRestricted: '=?',
      restrictedSelections: '='
    },
    template: require('../../../templates/directives/cms/category-restricted-select.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.creator = Application.access.user;
      var optionMap = {
        departments: 'linked_departments',
        locations: 'linked_locations',
        teams: 'linked_teams',
        grades: 'linked_grade',
        org_levels: 'linked_org_level',
        categories: 'linked_category'
      };

      self.multipleSelections = $scope.type === 'teams' || $scope.type === 'categories';
      self.arraySelections = $scope.type !== 'grades' && $scope.type !== 'org_levels';

      self.data = {};
      self.restrictedOptions = [];
      self.restrictedSelectionIds = [];
      self.selected;
      self.selections = [];

      var restrictedGroup = {}; 
      if ($scope.type !== 'categories') {
        restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.users && Application.access.profile.permissions.admin.users.user_group || {};
      }
      if ($scope.type === 'categories') {
        restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.content && Application.access.profile.permissions.admin.content.allowed_categories || {};
      }
      if ($scope.viewRestricted && $scope.restrictedSelections && $scope.restrictedSelections.length) {
        self.restrictedSelectionIds = $scope.restrictedSelections.map(restrictedSelection => restrictedSelection.value);
      }

      self.translations = {};
      self.getValue = function() {
        if (!optionMap[$scope.type]) {
          return null;
        }
        var results = [];
        var userCatValues = $scope.user && $scope.user[optionMap[$scope.type]];
        if ($scope.type === 'categories') {
          results = $scope.content[optionMap[$scope.type]];
        } else if ($scope.viewRestricted && userCatValues) {
          if (self.arraySelections) {
            results = userCatValues.filter(id => !self.restrictedSelectionIds.includes(id));
          } else {
            results = !self.restrictedSelectionIds.includes(userCatValues) ? userCatValues : [];
          }
        } else {
          results = userCatValues || [];
        }

        if (!results) {
          return null;
        }

        if (!self.arraySelections) {
          return results && [results] || null;
        }

        if (results.length) {
          return results;
        }

        return null;
      };
      self.setValue = function() {
        if (!optionMap[$scope.type]) {
          return null;
        }
        var context = $scope.type === 'categories' ? $scope.content : $scope.user;
        var valueSet = false;
        var value;
        if (!self.arraySelections) {
          value = self.selected;
          valueSet = true;
        }
        if (!self.multipleSelections) {
          value = [self.selected];
          valueSet = true;
        }
        if (!valueSet) {
          value = self.selections;
          if ($scope.viewRestricted) {
            // Makes sure not to overwrite uneditable values
            value = self.restrictedSelectionIds.concat(self.selections);
          }
        }
        context[optionMap[$scope.type]] = value;

        if ($scope.onChange) {
          $scope.onChange();
        }
      };
      var legacyName = function(item) {
        var name = '';
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.legacyName = item.name;
        item.lineage = [item._id];
        item.originalName = item.name;

        if (item.parent && self.data[item.parent]) {
          parent = self.data[item.parent];
          parentName = (parent.originalName || parent.name) + ' -> ';
          papa = parent.parent;
          item.legacyName = parentName + item.name;
          item.lineage.push(parent._id);
          self.data[item.parent].children.push(item._id);
        }

        if (papa && self.data[papa]) {
          papa = self.data[papa];
          papaName = (papa.originalName || papa.name) + ' -> ';
          item.legacyName = papaName + item.legacyName;
          item.lineage.push(papa._id);
          item.papa = papa;
          self.data[papa._id].children.push(item._id);
        }
        item.name = item.legacyName
      };

      self.sortCategories = function() {
        self.selections = [];
        var selected = self.getValue() || [];

        angular.forEach(($scope.options || []), function(cat) {
          self.data[cat._id] = cat
          self.data[cat._id].children = [];
          self.data[cat._id].value = cat._id;

          if (selected.indexOf(cat._id) !== -1) {
            if (!self.arraySelections || !self.multipleSelections) {
              self.selected = cat._id;
              return;
            }
            if (self.selections.indexOf(cat._id) === -1) {
              self.selections.push(cat._id);
            }
          }
        });

        for (var item in self.data) {
          legacyName(self.data[item]);
        }

        var restrictedProfile = [];
        if ($scope.type !== 'categories') {
          restrictedProfile = restrictedGroup[$scope.type] && restrictedGroup[$scope.type].length ? restrictedGroup[$scope.type] : [];
        }
        if ($scope.type === 'categories') {
          restrictedProfile = restrictedGroup && restrictedGroup.length ? restrictedGroup : [];
        }
        if ($scope.manager) {
          if (optionMap[$scope.type] && self.creator[optionMap[$scope.type]]) {
            var item = self.creator[optionMap[$scope.type]];
            restrictedProfile = Array.isArray(item) ? item : [item];
          }
        }

        self.restrictedOptions = [];
        self.restrictedOptionsMap = {};

        for (var key in self.data) {

          if (restrictedProfile.indexOf(key) !== -1 || (!$scope.manager && $scope.allowAll)) {
            if (!self.restrictedOptionsMap[key]) {
              self.restrictedOptionsMap[key] = true;
              self.restrictedOptions.push(self.data[key]);
            }

            if ($scope.type !== 'categories' && self.data[key].children && self.data[key].children.length) {
              for (var i = 0; i < self.data[key].children.length; i++) {
                if (!self.restrictedOptionsMap[self.data[key].children[i]]) {
                  self.restrictedOptionsMap[self.data[key].children[i]] = true;
                  self.restrictedOptions.push(self.data[self.data[key].children[i]]);
                }
              }
            }

          }
        }

        self.restrictedOptions.sort(function(a, b) {
          var textA = a.legacyName.toUpperCase();
          var textB = b.legacyName.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
      };

      self.initialize = function() {
        self.sortCategories();

        $scope.$watch('selection.selected', function(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          self.setValue();
        });

        $scope.$watch('selection.selections', function(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          self.setValue();
        });
      };

      self.initialize();

    }],
    controllerAs: 'selection'
  };
}]);
